import Vue from 'vue'
import TabelaComponent from './TabelaComponent'
import ErrosBox from './ErrosBoxComponent'
import ButtonSpinner from './ButtonSpinner'
import LoadingComponent from './LoadingComponent'
import LoadingComponent2 from './LoadingComponent2'
import LoadingFullComponent from './LoadingFullComponent'
import StatusComponent from './StatusComponent'
import BtnVoltar from './BtnVoltar'
import BoxCard01 from './BoxCard01'
import TempoRegressivo from './TempoRegressivo'

Vue.component('AppTabela', TabelaComponent)
Vue.component('AppErrosBox', ErrosBox)
Vue.component('AppBtnSpinner', ButtonSpinner)
Vue.component('AppLoading', LoadingComponent)
Vue.component('AppLoading2', LoadingComponent2)
Vue.component('AppLoadingFull', LoadingFullComponent)
Vue.component('AppStatus', StatusComponent)
Vue.component('AppBtnVoltar', BtnVoltar)
Vue.component('AppBoxCard01', BoxCard01)
Vue.component('TempoRegressivo', TempoRegressivo)



// WEBPACK FOOTER //
// ./src/components/registroComponentes.js